import { useState, useRef } from 'react';
import { original, rose, vaporwave, matrix } from 'react95/dist/themes';
import { BrowserRouter, Router, Routes, Route, Link, useNavigate} from "react-router-dom";
import { createGlobalStyle, ThemeProvider, createTheme} from 'styled-components';
import {
    AppBar,
  Button,
  MenuList,
  MenuListItem,
  ScrollView,
  Separator,
  Toolbar,
    Frame,
  Window,
    Handle,
    
  WindowContent,
  WindowHeader,
    TextInput,
    styleReset
} from 'react95';

const AboutPage = () => {
    const imgBox = useRef(null);
    const descBox = useRef(null);
    
    
    const Entries = [
        {
            name: "Sword Fighting Mechanics",
            link: "https://www.roblox.com/games/12698353564/Sword-Fighting-Mechanics",
            description: "A demo for sword fighting combat mechanics that I made for a commission years ago",
            Video: "1DOLBG4T-pP7neOEkscuFKV1qq9KlIFf3"
        },
        {
            name: "Pets and Shop Mechanics",
            link: "https://www.roblox.com/games/12698378247/Pets-and-Shop-Mechanics",
            description: "Shop mechanics I made for a game I worked on years ago never released called Anime Adventures. I later took that shop mechanics that",
            Video: ""
        },
        {
            name: "Turn Based Mechanics",
            link: "https://www.roblox.com/games/12618006945/Turn-Based-Mechanics",
            description: "Turned based mechanics I made for a game I worked on years ago that never released called Anime Adventures. ",
            Video: "1mNDStmno4X57L0_A8Uhv-hzTT5co6REm"
        },
        {
            name: "Bike Mechanics",
            link: "https://www.roblox.com/games/14902578038/Bike-Mechanics",
            description: "Bike mechanics I made for a commission years ago. Works best in first person and is controlled by the camera movement",
            Video: ""
        },
        {
            name: "Advanced Movement Mechanics",
            link: "https://www.roblox.com/games/15321484378/Advanced-Movement-Mechanics",
            description: "My job was to create a first person movement system, and I created a first person movement system. It was made for a commission for the currently unreleased Roblox game, “Bark”. Idk, I like this work as it’s the only one that’ll probably end up in an actual game. But at the same time it’s kinda simple. It comes packed with a crouch (hold c or or right thumbstick), Sprint (shift or left thumbstick), slide (shift + c or left thumbstick + right thumbstick), jumping (Space or A). Also comes with console and mobile support. The system uses renderstepped to update the orientation of the player based on the camera direction on every frame rendered. I also use renderstepped to do head bobbing effect by making a procedural camera bobbing animation. The sprint, jump, and crouch abilities on the other hand are functions that lower the camera and change the run speed and FOV.",
            Video: "1IfW4MsgcTASJ6fjAqPGsnsS1QVEbksuY"
        },
        {
            name: "Npcs",
            link: "https://www.roblox.com/games/11905364626/Npcs",
            description: "I really liked my work on this game. Basically I was asked to make a pathfinding system for a large open world environment. So I did a little experimenting for a while until I came up with a system that would pre calculate all possible paths for NPCs based on a set of predetermined start and end points. Then the system creates models without humanoids(because humanoids are pretty awful for performance) and only allows animators to load animations on them. You can even interact with them by clicking on them. The client wanted to make a gta type of game so I just had the NPCs freak out when you click on them. As if you shot them. Because of my optimization techniques the system can simulate up to 2500 NPCs running around with their own thoughts all at once.",
            Video: "1EJSCwLaO43kwg5xmMPboHczJAE-ZN9y5"
        }
        
    ]
    
    const [selectedEntry, setSelectedEntry] = useState(Entries[0]);
    const [photoIndex, setPhotoIndex] = useState(0);
    
    const loadContent = (desc) => {
        descBox.current.innerHtml = desc;
    }
    
    function linkOut(link)
    {
        window.location.href=link;
    }
    
    const navigate = useNavigate();
    
    const handleRedirect = (dir) => {
        navigate(dir);
    };
    
    const handleEntryClick = (entry) => {
      setSelectedEntry(entry);
      setPhotoIndex(0);
    };
    
    
    
    const listItems = Entries.map((Entry, index) =>
                                  <div key={index}>
                                  <MenuListItem style={{ whiteSpace: 'normal', height: 'auto' }}
 onClick={() => {setSelectedEntry(Entry);
        setPhotoIndex(0);}}>{Entry.name}</MenuListItem>
                                  <Separator />
                                  </div>
                                  );
    
    return (
            <ThemeProvider theme={rose}>
            <Window resizable className='window' style={{ display: 'block', height: '80vh', width: 'calc(90vh * (3/2))', maxWidth: "800px"}}>
            <WindowHeader className='window-title' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span>Roblox</span>
            <Button style={{ marginRight: '2px', width: '20px', height: '20px', padding: 0 }} onClick={() => handleRedirect('/Backpage')}>
            <span style={{ fontWeight: 'bold', fontSize: '12px' }}>✕</span>
            </Button>
            </WindowHeader>
            
            <WindowContent style={{ height: 'calc(100% - 33px)', padding: 0 }}>
            <Frame variant='well' className='footer' style={{ height: '100%', margin: 0, display: 'flex', flexDirection: "column" }}>
            <div style={{
                position: 'relative',
                flex: 4.5,
                height: '100%',
              }}>
                <iframe
                  src={`https://drive.google.com/file/d/${selectedEntry.Video}/preview`}
                  allow="autoplay"
                  allowFullScreen
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    border: 'none'
                  }}
                />
              </div>
            
              
              <div style={{ display: 'flex', flexDirection: 'row', flex: 3, overflow: 'hidden' }}>
                <ScrollView style={{ height: '100%', flex: 1 }}>
                  <MenuList style={{ display: 'flex', flexDirection: 'column' }}>
                    {listItems}
                  </MenuList>
                </ScrollView>
                <ScrollView style={{ height: '100%', flex: 1 }}>
                  <div style={{ padding: '1rem' }}>
                  {selectedEntry.description.split('\n\n').map((para, i) => (
                    <p key={i}>{para}</p>
                    ))}
                  </div>
                </ScrollView>
              </div>
                
              <div style={{ width: '100%', flex: 1, display: 'flex', flexDirection: 'column' }}>
                <Button 
                  className='big-button'
                  style={{ width: '100%', height: '100%', flex: 1 }} 
                  fstyle={{ height: '100%', width: '100%', fontSize: '2rem !important' }} 
                  onClick={() => linkOut(selectedEntry.link)}
                >
                  Check this out on Roblox
                </Button>
              </div>
              </Frame>
              
            </WindowContent>
            
          </Window>
          
          
    </ThemeProvider>
  );
}

export default AboutPage;
